export const jobFilesInitialState = {
  actionsMenuArtifactId: undefined as string | undefined,
} as const;
